// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */img[data-v-4bead44e],picture[data-v-4bead44e]{position:absolute;top:0;left:0;width:100%;height:100%;-o-object-fit:cover;object-fit:cover;-o-object-position:center center;object-position:center center}.is-initial-size[data-v-4bead44e]{display:block}.is-initial-size[data-v-4bead44e],.is-initial-size img[data-v-4bead44e]{position:relative;top:auto;left:auto}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
